import React from 'react';
import PropTypes from 'prop-types';
import { Tabs, Tab, Box, makeStyles } from '@material-ui/core';

const useStyles = makeStyles(() => ({
  tabsWrapper: {
    borderRadius: '8px',
    padding: '0px',
    margin: '0px',
    height: 50,
    color: 'black',
    paddingLeft: 0,
    marginLeft: 0,
    paddingRight: 0,
    marginRight: 0
  },
  tabsRoot: {
    minHeight: 'unset',
    height: '100%',
    backgroundColor: 'transparent',
    margin: 0,
    padding: 0,
    '& .MuiTabs-indicator': {
      display: 'none'
    },
    '& .MuiTabs-flexContainer': {
      margin: 0,
      padding: 0,
      gap: '8px'
    }
  },
  indicator: {
    backgroundColor: 'transparent'
  },
  tabRoot: {
    flex: 1,
    height: 50,
    maxWidth: 'none',
    minHeight: 'unset',
    textTransform: 'none',
    padding: '0 !important',
    margin: '0 !important',
    fontSize: '18px',
    fontWeight: 600,
    color: 'black',
    backgroundColor: 'transparent',
    position: 'relative',
    borderRadius: '0px'
  },
  tabSelectedPrimary: {
    backgroundColor: '#FFFFFF',
    borderRadius: '12px',
    color: 'black',
    fontWeight: 600,
    fontSize: '18px',
    boxShadow: 'none',
    transition: 'all 0.1s ease-in-out',
    padding: '0 !important'
  },
  tabSelectedDefault: {
    color: 'black',
    fontWeight: 600,
    fontSize: '18px',
    backgroundColor: 'transparent',
    '&::after': {
      content: '""',
      position: 'absolute',
      bottom: 0,
      left: 0,
      width: '100%',
      height: '4px',
      backgroundColor: '#C1BFFF',
      borderRadius: '999px'
    }
  },
  wrapperPrimary: {
    backgroundColor: '#512EAB26',
    padding: '0px'
  },
  wrapperDefault: {
    backgroundColor: 'white'
  }
}));

const a11yProps = index => ({
  id: `tab-${index}`,
  'aria-controls': `tab-panel-${index}`
});

const SectionTabs = ({
  value,
  onChange,
  tab1Label,
  tab2Label,
  variant = 'default',
  customTextStyle = null,
  indicatorColor = '#C1BFFF'
}) => {
  const classes = useStyles();

  const wrapperClass =
    variant === 'primary' ? classes.wrapperPrimary : classes.wrapperDefault;

  const selectedClass =
    variant === 'primary' ? classes.tabSelectedPrimary : classes.tabSelectedDefault;

  // Create inline styles for custom styling
  const customTabStyle = customTextStyle ? {
    ...customTextStyle,
    textTransform: 'none',
    minHeight: 'unset'
  } : {};

  const selectedTabStyle = customTextStyle ? {
    ...customTextStyle,
    textTransform: 'none',
    minHeight: 'unset',
    color: `${customTextStyle.color} !important`
  } : {};

  // Inject CSS for indicator color if needed
  React.useEffect(() => {
    if (indicatorColor !== '#C1BFFF') {
      const styleId = 'section-tabs-indicator';
      let styleElement = document.getElementById(styleId);

      if (!styleElement) {
        styleElement = document.createElement('style');
        styleElement.id = styleId;
        document.head.appendChild(styleElement);
      }

      styleElement.textContent = `
        .section-tabs-custom .MuiTab-root.Mui-selected::after {
          background-color: ${indicatorColor} !important;
        }
      `;
    }
  }, [indicatorColor]);

  return (
    <Box className={`${classes.tabsWrapper} ${wrapperClass} ${indicatorColor !== '#C1BFFF' ? 'section-tabs-custom' : ''}`}>
      <Tabs
        value={value}
        onChange={onChange}
        classes={{ root: classes.tabsRoot, indicator: classes.indicator }}
      >
        <Tab
          label={tab1Label}
          {...a11yProps(0)}
          classes={{
            root: classes.tabRoot,
            selected: selectedClass
          }}
          style={value === 0 ? selectedTabStyle : customTabStyle}
        />
        <Tab
          label={tab2Label}
          {...a11yProps(1)}
          classes={{
            root: classes.tabRoot,
            selected: selectedClass
          }}
          style={value === 1 ? selectedTabStyle : customTabStyle}
        />
      </Tabs>
    </Box>
  );
};

SectionTabs.propTypes = {
  value: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired,
  tab1Label: PropTypes.string.isRequired,
  tab2Label: PropTypes.string.isRequired,
  variant: PropTypes.oneOf(['default', 'primary']),
  customTextStyle: PropTypes.object,
  indicatorColor: PropTypes.string
};

SectionTabs.defaultProps = {
  variant: 'default',
  customTextStyle: {},
  indicatorColor: ''
};

export default SectionTabs;
